import { writable } from "svelte/store";

export let selectedActiveYear = writable(null);